import React from 'react';
import PropTypes from 'prop-types';

import { Title } from 'components/typography';
import PriceChanges from 'components/priceChanges';

import {
  metrics,
  commodity,
  commodityCost,
} from './scss/Commodity.module.scss';

const Commodity = ({ item }) => (
  <article className={commodity}>
    <Title value={item.commodity} fontStyle="regular" size="xs" />
    <div className={metrics}>
      {
        <span className={commodityCost}>
          N{item.marketPrice.toLocaleString()}
        </span>
      }
      <PriceChanges changes={item.changePercentage} changeType={item.type} />
    </div>
  </article>
);

Commodity.propTypes = {
  item: PropTypes.shape({
    commodity: PropTypes.string.isRequired,
    marketPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    changePercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
};

export default Commodity;
